export default __webpack_public_path__ + "static/media/logo_lit.d9d5956d.svg";